export default "__VITE_ASSET__Ciav0h2b__"